var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.tags),function(item){return _c('el-tag',{key:item.id,staticClass:"mr-2"},[_c('i',{staticClass:"el-icon-price-tag trans",attrs:{"size":"mini"}}),_vm._v(" "+_vm._s(item.name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }